export const SLIDE_NAVIGATOR_TITLE = 'HistoWiz - Slides Navigator';

export const SLIDE_NAVIGATOR_HEADER_TITLE = 'Slide Navigator';

export const OFFSET_LIMIT = 50;
